import React, {useEffect, useState} from 'react'
import SectorsAPI from '../../api/sectorsAPI';
import Label from '../roundedLabel';
import { useDispatch, useSelector } from "react-redux";
import {addFilterValue, deleteFilterValue} from '../../actions/filterActions';

export default function Sectors(props) {

    let [sectors, setSectors] = useState([]);

    let filteredSectors = useSelector(state => state.filters.selected.filter((filter) => filter.type === 'sector'));
    let initialFilters = useSelector(state => state.filters.initialFilters['sectors']);

    const dispatch = useDispatch();

    useEffect(
        () => {
            SectorsAPI.getCollection().then((collection) => {
               setSectors(collection);
            }).catch(error => {
                  console.log(error);
             });
        }, []
    );

    useEffect(
        () => {
            if (sectors.length === 0 || !initialFilters) { return; }
            initialFilters.map((filter) => {
                let item = sectors.find(sector => sector.industry.id === parseInt(filter));
                if (item) {
                    dispatch(addFilterValue(item.industry, 'sector'))
                }
            });
        }, [sectors, initialFilters]
    );


    return(
        <div className="grid-x grid-padding-x mar-top-10 mar-bot-10 filters__options">
            {sectors.map((item) => {
                item = item.industry;
                return <Label key={item.id} option={item}
                              add={() => dispatch(addFilterValue(item, 'sector'))}
                              delete={() => dispatch(deleteFilterValue(item, 'sector'))}
                              selected={!!filteredSectors.find((ind) => ind.id === item.id)} />
            })}
        </div>
    )

}